module.exports = __webpack_public_path__ + "img/BG_yellow.509be683.png";